import { FontAwesome5 } from '@expo/vector-icons';
import AsyncStorage from '@react-native-async-storage/async-storage';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import {
  ActivityIndicator,
  Pressable,
  StyleSheet,
  Text,
  View,
} from 'react-native';

import Styles from '../../styles';
import Colors from '../../styles/Colors';
import { CalcVariants, Choices, OptionScreenProps } from '../../types';

export default function OptionsScreen({
  setVisibleScreen,
  setQuestionTypes,
}: OptionScreenProps) {
  const [isLoading, setLoading] = useState(true);
  const [choices, setChoices] = useState<Choices>({
    plus: false,
    minus: false,
    times: false,
    divide: false,
  });

  useEffect(() => {
    const getData = async () => {
      try {
        const calcVariantChoices = await AsyncStorage.getItem(
          'CalcVariantChoices'
        );
        if (calcVariantChoices !== null) {
          setChoices(JSON.parse(calcVariantChoices));
        }
        setLoading(false);
      } catch (e) {}
    };
    getData();
  }, []);

  return (
    <View style={[Styles.container, styles.container]}>
      {isLoading && (
        <ActivityIndicator color={Colors.buttonLight} size="large" />
      )}
      {!isLoading && (
        <>
          <View style={styles.choiceContainer}>
            <View style={[styles.row]}>
              <ChoiceButton
                iconName="plus"
                title="Addition"
                setChoices={setChoices}
                choices={choices}
              />
              <ChoiceButton
                iconName="minus"
                title="Subtraction"
                setChoices={setChoices}
                choices={choices}
              />
            </View>
            <View style={[styles.row]}>
              <ChoiceButton
                iconName="divide"
                title="Division"
                setChoices={setChoices}
                choices={choices}
              />
              <ChoiceButton
                iconName="times"
                title="Multiplication"
                setChoices={setChoices}
                choices={choices}
              />
            </View>
          </View>
          <Pressable
            style={[
              Styles.btn,
              styles.nextBtn,
              {
                backgroundColor: Object.values(choices).includes(true)
                  ? Colors.buttonLight
                  : Colors.buttonDark,
              },
            ]}
            onPress={async () => {
              if (Object.values(choices).includes(true)) {
                const types = Object.entries(choices)
                  .filter((i) => i[1])
                  .map((i) => i[0] as CalcVariants);
                try {
                  await AsyncStorage.setItem(
                    'CalcVariantChoices',
                    JSON.stringify(choices)
                  );
                } catch (e) {}
                setQuestionTypes(types);
                setVisibleScreen('questions');
              }
            }}
          >
            <Text style={[Styles.text, styles.nextText]}>Next</Text>
          </Pressable>
        </>
      )}
    </View>
  );
}

function ChoiceButton({
  iconName,
  title,
  setChoices,
  choices,
}: {
  iconName: CalcVariants;
  title: string;
  setChoices(choices: Choices): void;
  choices: Choices;
}) {
  return (
    <Pressable
      style={[
        Styles.btn,
        styles.choiceBtn,
        {
          backgroundColor: choices[iconName]
            ? Colors.buttonLight
            : Colors.buttonDark,
        },
      ]}
      onPress={() => {
        const newChoices = { ...choices, [iconName]: !choices[iconName] };
        setChoices(newChoices);
      }}
    >
      <FontAwesome5 name={iconName} color="white" size={60} />
      <Text style={[Styles.text, styles.choiceText]}>{title}</Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  choiceContainer: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '95%',
  },
  nextBtn: {
    height: 80,
    width: '70%',
  },
  choiceBtn: {
    height: 130,
    width: 130,
  },
  nextText: {
    fontSize: 40,
  },
  choiceText: {
    fontSize: 19,
  },
  container: {
    paddingTop: '20%',
    paddingBottom: '15%',
  },
  row: {
    flexDirection: 'row',
  },
});
